<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,4C2,4,1,4,1,4C0.45,4,0,4.45,0,5C0,5,0,15,0,15C0,15.55,0.45,16,1,16C1,16,2,16,2,16C2.55,16,3,15.55,3,15C3,15,3,5,3,5C3,4.45,2.55,4,2,4C2,4,2,4,2,4ZM2,0C2,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,2,0,2C0,2.55,0.45,3,1,3C1,3,2,3,2,3C2.55,3,3,2.55,3,2C3,2,3,1,3,1C3,0.45,2.55,0,2,0C2,0,2,0,2,0ZM13.71,4.29C13.53,4.11,13.28,4,13,4C12.72,4,12.47,4.11,12.29,4.29C12.29,4.29,10.29,6.29,10.29,6.29C10.11,6.47,10,6.72,10,7C10,7.55,10.45,8,11,8C11.28,8,11.53,7.89,11.71,7.71C11.71,7.71,12,7.41,12,7.41C12,7.41,12,9,12,9C12,10.66,10.66,12,9,12C9,12,7.41,12,7.41,12C7.41,12,7.7,11.71,7.7,11.71C7.89,11.53,8,11.28,8,11C8,10.45,7.55,10,7,10C6.72,10,6.47,10.11,6.29,10.29C6.29,10.29,4.29,12.29,4.29,12.29C4.11,12.47,4,12.72,4,13C4,13.28,4.11,13.53,4.29,13.71C4.29,13.71,6.29,15.71,6.29,15.71C6.47,15.89,6.72,16,7,16C7.55,16,8,15.55,8,15C8,14.72,7.89,14.47,7.71,14.29C7.71,14.29,7.41,14,7.41,14C7.41,14,9,14,9,14C11.76,14,14,11.76,14,9C14,9,14,7.41,14,7.41C14,7.41,14.29,7.7,14.29,7.7C14.47,7.89,14.72,8,15,8C15.55,8,16,7.55,16,7C16,6.72,15.89,6.47,15.71,6.29C15.71,6.29,13.71,4.29,13.71,4.29C13.71,4.29,13.71,4.29,13.71,4.29ZM15,0C15,0,5,0,5,0C4.45,0,4,0.45,4,1C4,1,4,2,4,2C4,2.55,4.45,3,5,3C5,3,15,3,15,3C15.55,3,16,2.55,16,2C16,2,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'PivotTable',
} as DefineComponent
</script>
